import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  error: {},
  productTypes: {
    photos: [],
    fotobooks: [],
    calendars: [],
    gifts: [],
    postcards: [],
    decor: [],
    magnets: [],
    souvenirs: [],
    clothes: [],
    certificates: [],
  },
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    catchError(state, { payload }) {
      state.error = payload;
    },
    clearError(state) {
      state.error = {};
    },
    setProductTypes(state, { payload }) {
      state.productTypes = payload;
    },
  },
});

export const { catchError, clearError, setProductTypes } = commonSlice.actions;
export default commonSlice.reducer;
